import { render } from "./Reservations.vue?vue&type=template&id=39eda81a&scoped=true"
import script from "./Reservations.vue?vue&type=script&lang=js"
export * from "./Reservations.vue?vue&type=script&lang=js"

import "./Reservations.vue?vue&type=style&index=0&id=39eda81a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-39eda81a"]])

export default __exports__